var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 12"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M0 12h18v-2H0v2zm0-5h18V5H0v2zm0-7v2h18V0H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }